import React, { useState } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { Container, LoaderContainer } from './styled';
import { Icon, IconName } from '../Icons';
export const Loader = ({ playerInstance, className, styles }) => {
    const [isLoading, setIsLoading] = useState(!!playerInstance);
    const onWaiting = () => {
        setIsLoading(true);
    };
    const onCanPlay = () => {
        setIsLoading(false);
    };
    useEventListener('waiting', onWaiting, playerInstance);
    useEventListener('canplay', onCanPlay, playerInstance);
    return (React.createElement(Container, { className: `Loader ${className}`, style: styles.container },
        React.createElement(LoaderContainer, { style: styles.spinningContainer, className: "Loader-LoaderContainer", "data-test": "Loader-LoaderContainer", displayed: isLoading },
            React.createElement(Icon, { style: styles.icon, name: IconName.spinner, className: "Loader-Icon" }))));
};
Loader.defaultProps = {
    className: '',
    styles: {
        container: null,
        spinningContainer: null,
        icon: null,
    },
};
//# sourceMappingURL=index.js.map